import { SiteNav } from "./SiteNav";
import { Footer } from "./Footer";

// One wrapper for every public / pre-auth page — the landing and pricing
// pages plus the login/signup/verify/reset screens. They all share the same
// navbar and footer through here instead of each page re-declaring the chrome.
export function PublicLayout({ children }: { children: any }) {
  return (
    <div class="d-flex flex-column min-vh-100">
      <SiteNav />
      <main class="flex-grow-1 d-flex flex-column">{children}</main>
      <Footer />
    </div>
  );
}
